export default "__VITE_ASSET__ByB7vRFP__"